import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { ButtonBase, Container, Link } from "@mui/material";
// import logoHeader from "assets/images/color-logo.svg";
// import logoHeader from "assets/images/home-page-images/Logo.png";
import logoHeader from "assets/images/home-page-images/TavloAI.png";

// import logoHeader from "assets/images/home-page-images/TavloAILOGO.svg";

import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProfileAysnc } from "features/actions/auth";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import { styled, alpha } from "@mui/material/styles";
import React from "react";
import menuIcon from "assets/images/small-logos/new-burger-icon.svg";
import HamburgerMenu from "assets/images/home-page-images/HamburgerMenu.png";

import { useMediaQuery } from "react-responsive";
import ClearIcon from "@mui/icons-material/Clear";

function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const [colorChange, setColorchange] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [isProfileFetched, setIsProfileFetched] = useState(false);
  const { getprofile } = useSelector((state) => state.auth);
  const changeNavbarColor = () => {
    if (window.scrollY >= 80) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };
  window.addEventListener("scroll", changeNavbarColor);
  const data = [
    { name: "About", path: "about" },
    { name: "Pricing", path: "pricing" },
    { name: "Insight", path: "insight" },
    { name: "Contact us", path: "contact" },
  ];
  const [loggedInUser, setLoggedInUser] = useState(false);

  useLayoutEffect(() => {
    const auth = localStorage.getItem("token");
    if (auth) {
      setLoggedInUser(true);
      dispatch(getProfileAysnc());
    }
  }, []);

  const ToggleBar = () => {
    setToggle((prev) => !prev);
  };

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 576px)" });

  const StyledMenu = styled((props) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  ))(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: 5,
      marginTop: theme.spacing(1),
      Width: 40,
      color: "#318BEC",
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      "& .MuiMenu-list": {
        padding: "0px 0",
      },
      "& .MuiMenuItem-root": {
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: "318BEC",
        },
        "&:active": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity
          ),
        },
      },
    },
  }));

  const handleDashboard = async () => {
    setIsProfileFetched(false);
    try {
      await dispatch(getProfileAysnc());
      setIsProfileFetched(true);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (isProfileFetched) {
      if (getprofile?.businesses?.length > 0) {
        navigate("/dashboard");
      } else {
        navigate("/my-business");
      }
    }
  }, [isProfileFetched, getprofile, navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setToggle(false); // close dropdown
      }
    };

    if (toggle) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [toggle]);
  return (
    <MDBox
      // className={colorChange ? "navbar colorChange" : "navbar"}
      sx={{
        backgroundColor: "#fff",
        position: "fixed",
        top: "0px",
        zIndex: "3",
        width: "100%",
      }}
    >
      <MDBox sx={{ borderBottom: "1px solid #318BEC", position: "relative" }}>
        <MDBox
          sx={{
            width: "95.4%",
            height: {
              xs: "50px",
              sm: "auto",
              md: "auto",
            },
            margin: "auto",
          }}
        >
          <MDBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              pt: {
                xs: "10px",
                sm: "2rem",
                md: "1.2rem",
              },
              pb: {
                xs: "0px",
                sm: "0.5rem",
                md: "0.5rem",
              },
              // paddingBottom: "0.5rem",
            }}
          >
            <MDBox
              sx={{
                zIndex: "4",
                width: "120px",
                pl: {
                  xs: 0,
                  sm: 7,
                  md: 7,
                },

                "@media (min-width:768px)": { width: "220px" },
              }}
            >
              <NavLink to="/">
                <MDBox
                  component="img"
                  src={logoHeader}
                  alt="background"
                  sx={{
                    width: {
                      xs: "117px",
                      sm: "95%",
                      md: "100%",
                    },

                    height: {
                      xs: "26px",
                      sm: "657px",
                      md: "auto",
                    },
                  }}
                />
              </NavLink>
            </MDBox>

            <MDBox
              sx={{
                mt: -2,
                pl: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "5.1rem",
                flex: 1,
                "@media (max-width:768px)": {
                  display: "none",
                },
              }}
            >
              <NavLink
                to="/about"
                style={({ isActive }) => ({
                  color: isActive ? "#318BEC" : "#000",
                  textDecoration: "none",
                  fontWeight: isActive ? 600 : 400,
                  fontSize: "16px",
                  fontFamily: "Poppins",
                })}
              >
                About
              </NavLink>
              <NavLink
                to="/pricing"
                style={({ isActive }) => ({
                  color: isActive ? "#318BEC" : "#000",
                  textDecoration: "none",
                  fontWeight: isActive ? 600 : 400,
                  fontSize: "16px",
                  fontFamily: "Poppins",
                })}
              >
                Pricing
              </NavLink>
              <NavLink
                to="/insight"
                style={({ isActive }) => ({
                  color: isActive ? "#318BEC" : "#000",
                  textDecoration: "none",
                  fontWeight: isActive ? 600 : 400,
                  fontSize: "16px",
                  fontFamily: "Poppins",
                })}
              >
                Insights
              </NavLink>
              <NavLink
                to="/contact"
                style={({ isActive }) => ({
                  color: isActive ? "#318BEC" : "#000",
                  textDecoration: "none",
                  fontWeight: isActive ? 600 : 400,
                  fontSize: "16px",
                  fontFamily: "Poppins",
                })}
              >
                Contact us
              </NavLink>
            </MDBox>
            {toggle || !isTabletOrMobile ? (
              <MDBox
                ref={dropdownRef}
                sx={{
                  // mb: 1,
                  "@media (min-width:576px)": {
                    display: "block",
                    position: "static",
                    width: "auto",
                    background: "none",
                    height: "auto",
                  },
                  position: "fixed",
                  top: 51,
                  right: toggle ? 0 : "-100%",
                  width: "100%",
                  height: "fit-content",
                  backgroundColor: "#fff",
                  zIndex: 20,
                  pb: {
                    xs: 0,
                    sm: 0,
                  },
                  pr: {
                    xs: 0,
                    sm: 0,
                  },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "end",
                  justifyContent: "start",
                  transition: "left 0.7s ease-in-out",
                  boxShadow: {
                    xs: "0px 8px 10px rgba(0,0,0,0.3)",
                    sm: "none",
                  },
                }}
              >
                <MDBox
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "end",
                    // gap: 2,
                  }}
                >
                  <MDBox
                    sx={{
                      display: {
                        xs: "flex",
                        sm: "none",
                      },
                      width: "100%",
                      flexDirection: "column",
                      justifyContent: "center",
                      // pt: 2,
                      // gap: 2,
                      alignItems: "start",
                    }}
                  >
                    {data.map((text, idx) => (
                      <MDBox
                        sx={{
                          width: "100%",
                          borderBottom: "1px solid #ccc",
                          display: "flex", // make it a flex container
                          pl: 2,
                          py: 0.5,
                        }}
                      >
                        <NavLink
                          key={idx}
                          to={`/${text.path}`}
                          style={{
                            width: "100%", // full width
                            fontSize: "12px",
                            color: "#090909",
                            textDecoration: "none",
                            fontWeight: 400,
                            fontFamily: "Poppins",
                            padding: "4px 0", // optional spacing
                            display: "block", // block to occupy full row
                          }}
                          onClick={() => setToggle(false)}
                        >
                          {text.name}
                        </NavLink>
                      </MDBox>
                    ))}
                  </MDBox>

                  <MDBox>
                    {loggedInUser ? (
                      <MDButton
                        component={Link}
                        sx={{
                          display: {
                            xs: "none",
                            sm: "inline-flex",
                          },
                          color: "#FFFFFF",
                          border: "2px solid transparent",
                          padding: "9px 40px 9px 40px",
                          borderRadius: "188px",

                          background:
                            "linear-gradient(63.54deg, #49A3F1 -5.54%, #1A73E8 100%)",
                          fontSize: "16px",
                          fontWeight: "700",
                          lineHeight: "24px",
                          textAlign: "left",
                          fontFamily: "urbanist",
                        }}
                        onClick={handleDashboard}
                      >
                        Dashboard
                      </MDButton>
                    ) : (
                      <MDBox
                        sx={{
                          mt: -1,
                          display: "flex",
                          gap: {
                            xs: 3,
                            sm: 2,
                          },
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                          },
                          justifyContent: "center",
                          alignItems: {
                            xs: "end",
                            sm: "center",
                          },
                          // alignItems: "center",
                        }}
                      >
                        <MDButton
                          component={Link}
                          sx={{
                            display: { xs: "none", sm: "block", md: "block" },
                            background: "transparent",
                            color: "#318BEC",
                            border: "1px solid #318BEC",
                            px: 1.5,
                            py: 0.5,
                            borderRadius: "188px",
                            fontSize: "14px",
                            fontWeight: "700",
                            lineHeight: "20px",
                            textAlign: "left",
                            fontFamily: "urbanist",
                            textTransform: "none",
                            minHeight: "22px",
                            textAlign: "center",
                            minWidth: "80px",
                          }}
                          onClick={() => navigate("/sign-in")}
                        >
                          Login
                        </MDButton>

                        <MDButton
                          component={Link}
                          sx={{
                            display: { xs: "none", sm: "block", md: "block" },
                            color: "#FFFFFF",
                            border: "2px solid transparent",
                            padding: "6px 25px 6px 25px",
                            borderRadius: "14px",
                            // ml: 2,
                            background:
                              "linear-gradient(63.54deg, #49A3F1 -5.54%, #1A73E8 100%)",
                            fontSize: "17px",
                            fontWeight: "600",
                            lineHeight: "24px",
                            textAlign: "left",
                            fontFamily: "urbanist",
                            textTransform: "none",
                          }}
                          onClick={() => navigate("/sign-up")}
                        >
                          Register
                        </MDButton>
                      </MDBox>
                    )}
                  </MDBox>
                </MDBox>
              </MDBox>
            ) : null}

            <MDBox
              sx={{
                "@media (min-width:576px)": { display: "none" },
                display: "block",
                zIndex: 10,
                mt: -1.5,
              }}
            >
              {loggedInUser ? (
                <ButtonBase onClick={handleDashboard}>
                  <MDBox
                    sx={{
                      color: "#FFFFFF",
                      border: "2px solid transparent",
                      px: 2,
                      py: 0.8,
                      borderRadius: "188px",
                      background:
                        "linear-gradient(63.54deg, #49A3F1 -5.54%, #1A73E8 100%)",
                      fontSize: "14px",
                      fontWeight: "700",
                      lineHeight: "14px",
                      textAlign: "center",
                      fontFamily: "urbanist",
                    }}
                  >
                    Dashboard
                  </MDBox>
                </ButtonBase>
              ) : (
                <>
                  <MDBox
                    component={Link}
                    sx={{
                      background: "transparent",
                      color: "#318BEC",
                      border: "1px solid #318BEC",
                      px: 2,
                      py: 0.3,
                      borderRadius: "100px",
                      fontSize: "10px",
                      fontWeight: "700",
                      lineHeight: "10px",
                      textAlign: "left",
                      fontFamily: "urbanist",
                      textTransform: "none",
                      height: "18px",
                      width: "73px",
                      mr: 1,
                    }}
                    onClick={() => navigate("/sign-in")}
                  >
                    Login
                  </MDBox>
                  <MDBox
                    component={Link}
                    sx={{
                      background: "#318BEC",
                      color: "#fff",
                      border: "1px solid #318BEC",
                      px: 2,
                      py: 0.3,
                      borderRadius: "100px",
                      fontSize: "10px",
                      fontWeight: "700",
                      lineHeight: "10px",
                      textAlign: "left",
                      fontFamily: "urbanist",
                      textTransform: "none",
                      height: "18px",
                      width: "73px",
                    }}
                    onClick={() => navigate("/sign-up")}
                  >
                    Register
                  </MDBox>
                </>
              )}
              <Button
                onClick={ToggleBar}
                sx={{ minWidth: "auto", pl: 1.5, pr: 0 }}
              >
                {toggle ? (
                  <MDBox
                    component="img"
                    src={HamburgerMenu}
                    alt="Woman"
                    sx={{
                      width: 18,
                      height: 12,
                    }}
                  />
                ) : (
                  <img
                    src={HamburgerMenu}
                    alt="menu icon"
                    style={{ width: 18, height: 12 }}
                  />
                )}
              </Button>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

export default Header;
